import React, { Component } from 'react';
import { Wrapper } from './style';
import { formatMessage } from '../../CurrentLocale';

class SearchableList extends Component<Props, State> {
  state = { query: '' };

  handleChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({ query: e.target.value });
  };

  render() {
    const {
      items = [],
      placeholder = '',
      selected = [],
      onToggle,
      field
    } = this.props;
    const q = String(this.state.query || '')
      .trim()
      .toLowerCase();
    const visible = items
      .filter(item => item.label.toLowerCase().includes(q))
      .sort((a, b) => b.count - a.count);

    return (
      <Wrapper>
        <div className="searchlist">
          <input
            type="text"
            className="searchlist__input"
            placeholder={placeholder}
            value={this.state.query}
            onChange={this.handleChange}
          />
          <div className="searchlist__items">
            {visible.length > 0 ? (
              <React.Fragment>
                {visible.map((item, i) => (
                  <div
                    key={item.value || i}
                    className="searchlist__items__item"
                  >
                    <div className="searchlist__items__item__left">
                      <input
                        type="checkbox"
                        id={`${field}-item-${item.value}-${i}`}
                        className="searchlist__items__item__input"
                        value={item.value}
                        checked={selected.includes(item.value)}
                        onChange={e =>
                          onToggle &&
                          onToggle(field, item.value, e.target.checked)
                        }
                      />
                      <label
                        htmlFor={`${field}-item-${item.value}-${i}`}
                        className="searchlist__items__item__label"
                      >
                        {item.label}
                      </label>
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ) : (
              <p className="searchlist__noresult">
                {formatMessage({ id: 'advancedSearch.no_result' })}
              </p>
            )}
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default SearchableList;



// WEBPACK FOOTER //
// ./src/components/SearchableList/index.js